import CommentImage from 'components/BordComentsAndObservations/components/CommentImage/CommentImage';
import { ICustomerChatComment } from 'types/customerChat.types';
import {
  formatCustomerChatDateTime,
  isBackofficeOperationsOutgoingMessage
} from 'utils/customerChat.utils';

import './CustomerChatMessage.scss';

interface ICustomerChatMessage {
  comment: ICustomerChatComment;
  viewerUserId?: number;
  viewerDisplayNameNorm: string;
  defaultUserLabel?: string;
}

const CustomerChatMessage = ({
  comment,
  viewerUserId,
  viewerDisplayNameNorm,
  defaultUserLabel = 'Usuario'
}: ICustomerChatMessage) => {
  const isOutgoing = isBackofficeOperationsOutgoingMessage(comment, viewerUserId, viewerDisplayNameNorm);
  const displayName = comment.user?.trim() || defaultUserLabel;
  const timeLabel = formatCustomerChatDateTime(comment.createdAt);

  if (isOutgoing) {
    return (
      <div className="customerChatMessage customerChatMessageOutgoing">
        <div className="customerChatMessageBubble">
          <div className="customerChatMessageMeta">
            <span className="customerChatMessageAuthor">{displayName}</span>
            <span className="customerChatMessageTime">{timeLabel}</span>
          </div>
          {!!comment.comments && <p className="customerChatMessageText">{comment.comments}</p>}
          {comment.image?.imageUrl && (
            <CommentImage
              imageUrl={comment.image.imageUrl}
              displayDownloadButton={false}
              useCustomerChatExpandedImageModal
            />
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="customerChatMessage customerChatMessageIncoming">
      <div className="customerChatMessageMeta">
        <span className="customerChatMessageAuthor">{displayName}</span>
        <span className="customerChatMessageTime">{timeLabel}</span>
      </div>
      <div className="customerChatMessageBubble">
        {!!comment.comments && <p className="customerChatMessageText">{comment.comments}</p>}
        {comment.image?.imageUrl && (
          <CommentImage
            imageUrl={comment.image.imageUrl}
            displayDownloadButton={false}
            useCustomerChatExpandedImageModal
          />
        )}
      </div>
    </div>
  );
};

export default CustomerChatMessage;
